import { Container, Stack, Title } from "@mantine/core";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import { ToolAllowlistSection } from "../features/toolAllowlist/ToolAllowlistSection";

// Страница «Настройки → Разрешённые инструменты». Тонкий контейнер
// над секцией управления per-(org, role) allow-list'ом инструментов — как
// `ToolBlacklistPage`.
export function ToolAllowlistPage(): ReactElement {
  const { t } = useTranslation();
  return (
    <Container py="xl">
      <Stack gap="xl">
        <Title order={1}>{t("toolAllowlist.pageTitle")}</Title>
        <ToolAllowlistSection />
      </Stack>
    </Container>
  );
}
